<template>
    <div class="play-wrap"
        :class="{
            'at-right': !!atRight, 
            'user-self': !!userInfo.isSelf, 
            'now-pking': gamersInPk.includes(gamerID), 
            'select-user': isSelect,
        }"
    > 
        <template v-if="userInfo.id">
            <div class="user-info relative" @click="selectUser">
                <div v-if="msgInfo.key" class="msg absolute" :class="`msg-${msgInfo.tag}`">
                    {{ $t(`goldenFlower.${msgInfo.key}`, { val: msgInfo.val }) }}
                    <i class="tri-down"></i>
                </div>
                <UserAvatar
                    :class="userInfo.isSelf ? '': 'active' " 
                    :size="'var(--avatar-size)'"
                    :src="userInfo.avatar"
                />
                <nameTag 
                    class="name-tag"
                    :userName="userInfo.name" 
                    :balance="userInfo.chips"
                    :countingDown="roundTime"
                    :isBanker="isBanker"
                    :isRound="currentTurnPlayerId === userInfo.id"
                    :lv="userInfo.lvl"
                />
            </div>
            <!-- 左右分界 --> 
            <div class="cards-info"
                :style="{}"
            >
                <div class="cards-wrap"
                    :style="{}"
                >
                    <!-- 牌型标识：任意已看牌的玩家都显示 -->
                    <CardType v-if='userInfo.isWatchCards' :isSelf="userInfo.isSelf" :type="userInfo.cardType" />
                    <!-- 自动开牌，不需要手动看牌按钮 -->

                    <pokerCard
                        v-for="i01 in 3"
                        :key="i01"
                        :cardName="aAllCards[0]"
                        :width="`${iCardWidth}px`"
                        class="opacity-0"
                    />
                    <!-- ↑ 纯占位，不可见 --> 
                    <!-- ↓ 真的牌，可见 --> 
                    <div class="real-cards"
                        v-show="aLocalCards.length" 
                        :key="gamerID + '-' + aLocalCards.length"
                    >
                        <TransitionGroup name="moveup">
                            <pokerCard
                                v-for="(it, index) in aLocalCards.slice(0,3)"
                                :key="index"
                                :cardName="getCardName(it.suit, it.rank)"
                                :width="`${iCardWidth}px`"
                                real
                            />
                        </TransitionGroup>
                    </div>
                    
                    <div v-if="gameWinner" class="result-pics">
                        <Transition name="bounce">
                            <img :src="oResultPic.win" 
                                v-if="gameWinner.includes(gamerID)"
                            />
                            <img :src="oResultPic.fail" 
                                v-else-if="gamersInPk.includes(gamerID)"
                            />
                        </Transition>
                    </div>
                </div>
                <!-- 
                    ↑ 发牌后显示牌 
                    ↓ 开局后显示金额 
                -->
                <wagerAmount
                    v-if="userInfo.inGame" 
                    ref="wagerRef"
                    :wagerValue="userInfo.totalBet"
                    :atRight="!!atRight"
                />
            </div>
        </template>
        <!--
            分界
        -->
        <div v-else
            class="empty-figure"
        >
            <span class="empty-avatar">
                {{ $t('goldenFlower.empty') }}
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup> 
// @ts-ignore
import nameTag from './nameTag.vue'; 
// @ts-ignore
import wagerAmount from './wagerAmount.vue'; 
// @ts-ignore
import pokerCard from './pokerCard.vue'; 
// @ts-ignore
import CardType from './cardType.vue'
import { useUserStore } from '~/stores/user';
import {aAllCards} from '~/pages/casino/jisuzhajinhuaGame/ts/cardsConstant';
import winCn from '../img/win-cn.webp'; 
import winEn from '../img/win-en.webp'; 
import failCn from '../img/fail-cn.webp'; 
import failEn from '../img/fail-en.webp'; 
import type { Player, ActionMsg } from '../ts/types';

const props = withDefaults(defineProps<{
    atRight: boolean,
    userInfo: Player,
    // '1' | '2' | '3' | '4' | '5'
    gamerID: string,
    // '1' | '2' | '3' | '4' | '5'
    gameWinner: string,
    // 12, 13, 25, 34,
    gamersInPk: string,
    isSelect: boolean,
    roundTime: number,
    isBanker: boolean,
    currentTurnPlayerId: number,
    msgInfo?: ActionMsg,
}>(), {
    userInfo: () => ({} as Player),
    msgInfo: () => ({} as ActionMsg)
});
const emits = defineEmits<
    {
        viewCard: [],
        selectUser: [val:any],
    }
>();
const wagerRef = ref();
const userStore = useUserStore();
const $i18n = useNuxtApp().$i18n;
const sLang = computed(()=>{
    return $i18n.locale.value;
});

const iCardWidth = computed(()=>{
    return props.userInfo.isSelf ? 38 : 30;
});

const aLocalCards = ref([]);


const fnInsert = async (aNew) => {
    console.log('fnInsert', aNew);
    aLocalCards.value.splice(0, 1/0); 
    await nextTick(); 
    for (const oOneCard of aNew){
        if (aLocalCards.value.length >= 3) break;
        aLocalCards.value.push(oOneCard);
        await Promise.allSettled([
            nextTick(),
            Sleep(125),
        ]);
    }
};

const insertCoin = ()=>{
    wagerRef.value?.fnInsert?.();
}

const getCardName = (suit = '', rank = '') => suit + rank;

// 看牌
const viewCard = () =>{
    emits('viewCard');
}

watch(
    () => props.userInfo.cards,
    (aNew, aOld)=>{
        console.log(`用户 ${props.gamerID} 的牌: `, deepCopy(aNew)); 
        if (!aNew?.length){
            aLocalCards.value.splice(0, 1/0); 
        }else if(aNew.length > (aOld?.length || 0)){
            fnInsert(aNew);
        } else if (aNew.length === (aOld?.length || 0)){
            // 长度相同但内容从占位切换为真实牌时，也执行发牌动画
            const oldHasFace = (aOld || []).some(it => it && (it.suit || it.rank));
            const newHasFace = (aNew || []).some(it => it && (it.suit || it.rank));
            if (!oldHasFace && newHasFace){
                fnInsert(aNew);
            } else {
                aLocalCards.value = aNew;
            }
        } else {
            aLocalCards.value = aNew;
        }
    },
    { immediate: true, deep: true }
);

const oResultPic = computed(()=>{
    if (sLang.value == 'cn'){
        return {
            win: winCn,
            fail: failCn,
        }
    }
    return {
        win: winEn,
        fail: failEn,
    }; 
}); 

const selectUser = () => {
    if (props.userInfo.isSelf || !props.isSelect) return;
    emits('selectUser', props.userInfo);
}

defineExpose({
    insertCoin
})
</script>

<style lang="scss" scoped>
.play-wrap{
    display: flex;
    justify-content: flex-start; 
    align-items: center; 
    --avatar-size: 50px;
}


.empty-figure{
    width: var(--avatar-size);
    height: var(--avatar-size);
    display: flex;
    justify-content: center; 
    align-items: center; 
    .empty-avatar{
        width: 40px;
        height: 40px; 
        background: rgba(45, 45, 45, 0.77);
        border: 1px solid rgba(0, 0, 0, 1);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 100px; 
        text-align: center; 
        font-weight: 400;
        font-size: 10px;
        text-align: center;
        vertical-align: middle;
        display: flex;
        justify-content: center; 
        align-items: center; 
        color: rgba(255, 255, 255, 0.5);
    }
}


.user-info{
    display: flex;
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    .name-tag{
        margin: -3px 0 0;
    }
    .user-avatar{
        border: 1px solid rgba(0, 0, 0, 0.6);
        // box-shadow: 0px 0px 0px 6px rgba(0, 0, 0, 0.6) inset; 
    }
    .msg {
        white-space: nowrap;
        color: #16171B;
        font-weight: 500;
        font-size: 10px;
        padding: 2px;
        text-align: center;
        min-width: 34px;
        height: 14px;
        line-height: 10px;
        border-radius: 33px;
        background: #02B780;
        top: -21px;
        left: 50%;
        transform: translateX(-50%);
        padding: 2px 4px;
        .tri-down {
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #02B780;
            position: absolute;
            bottom: -6px;
            left: 50%;
            transform: translateX(-50%);
        }
        &-0 {
            background: #D9D9D9;
            .tri-down {
                border-top-color: #D9D9D9;
            }
        }
        &-1 {
            color: #fff;
            background: #F88045;
            .tri-down {
                border-top-color: #F88045;
            }
        }
        &-2 {
            background: #02B780;
            .tri-down {
                border-top-color: #02B780;
            }
        }
    }
}


.cards-info{
    --gap: 10px;
    display: flex;
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    margin-bottom: 5px;
    margin-left: var(--gap); 
    align-self: flex-end; 
    .cards-wrap{
        margin: 0 0 5px;
        position: relative; 
        .result-pics{
            position: absolute;
            top: 0;
            left: 0%;
            right: 0%; 
            margin: 0 -5px; 
            transform: translateY(calc(-100% + 5px)); 
            img{
                width: 100%; 
                max-width: 100px;  
                margin: 0 auto; 
            }
        }
        .one-card{
            filter: drop(0px 0px 5px rgba(0, 0, 0, 0.5));
            & + .one-card{
                margin-left: -6px;
            }
        }
        .real-cards{
            position: absolute;
            top: 0;
            left: 0; 
        }

        .status-tag  {
            min-width: 68px;
            height: 22px;
            padding: 1px;
            font-weight: 600;
            border-radius: 22px;
            font-size: 12px;
            z-index: 1;
            overflow: hidden;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tag-other {
            cursor: default;
            min-width: 40px;
            font-size: 10px;
            height: 18px;
            color: rgb(253, 217, 53);
            font-weight: normal;
        }
    }
}


.at-right {
    flex-flow: row-reverse;
    .cards-info{
        margin-left: 0; 
        margin-right: var(--gap); 
    }
}

.pking{
    .user-info{
        z-index: 3; // 正在 pk 的玩家需要抬高 
    }
}

.user-self{
    .cards-info{
        margin-left: 12px;
        margin-bottom: -15px; 
        align-self: center;  
        .one-card{
            margin: 0 12px 0 0 !important;  
        }
    }
}

.now-pking,
.select-user{
    .user-info{
        z-index: 4; 
    }
}

.select-user {
    .active {
        border: 1px solid #02B780;
        filter: drop-shadow(0px 0px 7px rgb(9, 136, 58));
        cursor: pointer;
    }
}

// ↓ 动画 ----------------- 

.bounce-enter-active {
    animation: bounce-in 0.5s;
    // animation-delay: 0.5s;
}

.bounce-leave-active {
    // animation: bounce-in 0.5s reverse;
    animation: none; 
}

@keyframes bounce-in {
    0% {
        transform: scale(0) translateY(20px);
        opacity: 0;
    }
    50% {
        transform: scale(1.2) translateY(10px); 
        opacity: 0;
    }
    100% {
        transform: scale(1) translateY(0);
        opacity: 1;
    }
}

.moveup-enter-active {
    animation: move-up 0.4s;
}

.moveup-leave-active {
    animation: none; 
}

@keyframes move-up {
    0% {
        transform: translateY(20px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

</style>

